import { Typography } from "antd";
import { Notification } from "@contexts/Notifications/context";
import * as S from "./styles";
import { formatDate } from "@utils/formatters";

interface Props {
  notification: Notification;
}

export function NotificationItem({ notification }: Props) {
  return (
    <S.Wrapper>
      <S.Container $read={notification.read}>
        <Typography.Text>{notification.message}</Typography.Text>

        {notification.actionUrl && (
          <S.ActionLink href={notification.actionUrl}>Ver agora</S.ActionLink>
        )}
      </S.Container>

      <S.Date>
        {formatDate(notification.createdAt, "DD/MM/YYYY hh:mm A")}
      </S.Date>
    </S.Wrapper>
  );
}
